export default class contentCustomization {
    constructor() {
        return {
            scope: {},
            template: require('../../../../views/maileditor/content-customization.html'),
            controller: ['$scope', '$element', '$attrs', 'Segment', 'Tag', 'EditorEventHandler', (scope, element, attrs, Segment, Tag, EditorEventHandler) => {
                scope.tags = EditorEventHandler.tags;
                scope.segments = EditorEventHandler.segments;

                let getShowName = () => {

                    let getShowNameFromId = (items, id) => {
                        let showName;

                        angular.forEach(items, (element) => {
                            if (element.id == id) {
                                showName = element.name;
                            }
                        });

                        return showName;
                    };

                    let tag = parent.attr('data-rule-show-tag');
                    let segment = parent.attr('data-rule-show-segment');

                    if (tag) {
                        scope.hasShowTag = true;
                        scope.hasShowSegment = false;
                        scope.showTagName = getShowNameFromId(scope.tags, parseInt(tag));
                    } else if (segment) {
                        scope.hasShowTag = false;
                        scope.hasShowSegment = true;
                        scope.showSegmentName = getShowNameFromId(scope.segments, parseInt(segment));
                    } else {
                        scope.hasShowTag = false;
                        scope.hasShowSegment = false;
                    }
                };

                scope.showOverlay = false;
                let parent = element.parent().parent();

                scope.contentCustomization = {
                    blockTag: undefined,
                    blockSegment: undefined
                };

                scope.blockTag = parseInt(parent.attr('data-rule-show-tag'));
                scope.blockSegment = parseInt(parent.attr('data-rule-show-segment'));
                scope.toggleShowTag = ! scope.blockSegment;
                if (scope.blockTag) {
                    scope.contentCustomization.blockTag = scope.blockTag;
                } else if (scope.blockSegment) {
                    scope.contentCustomization.blockSegment = scope.blockSegment;
                }

                getShowName();

                let hasShowRules = () => {
                    return scope.contentCustomization.blockTag || scope.contentCustomization.blockSegment;
                };

                scope.hasRules = () => {
                    return hasShowRules();
                };

                scope.addShowTag = (item) => {
                    parent.attr('data-rule-show-tag', item);
                    scope.toggleShowTag = true;
                    getShowName();
                };

                scope.addShowSegment = (item) => {
                    parent.attr('data-rule-show-segment', item);
                    scope.toggleShowTag = false;
                    getShowName();
                };

                scope.clearShow = () => {
                    parent.removeAttr('data-rule-show-segment');
                    parent.removeAttr('data-rule-show-tag');

                    scope.contentCustomization.blockTag = undefined;
                    scope.contentCustomization.blockSegment = undefined;
                    getShowName();
                };

                scope.clearTags = () => {
                    parent.removeAttr('data-rule-show-tag');
                    parent.removeAttr('data-rule-prioritize-tag');

                    scope.contentCustomization.blockTag = undefined;
                    scope.contentCustomization.prioTags = undefined;
                };

                scope.clearSegments = () => {
                    parent.removeAttr('data-rule-show-segment');
                    parent.removeAttr('data-rule-prioritize-segment');

                    scope.contentCustomization.blockSegment = undefined;
                    scope.contentCustomization.prioSegments = undefined;
                };

                scope.toggleShow = () => {
                    scope.showOverlay = ! scope.showOverlay;
                };

                scope.selectClose = () => {
                    element.find('.ui-select-container').controller('uiSelect').open = false;
                };
            }]
        }
    }
};
